<script lang="ts" setup>
import type { FieldDefinition } from "~/models/Automation";

const { editable, search, noCopy, fields, withValues } = defineProps<{
    editable?: any;
    search?: string;
    noCopy?: boolean;
    fields: FieldDefinition[];
    withValues?: boolean;
}>();

defineEmits<{
    (e: "update:editable", v: FieldDefinition | undefined): void;
    (e: "update:deletable", v: FieldDefinition | undefined): void;
    (e: "saved", v: { to: FieldDefinition; from: FieldDefinition }): void;
}>();

const filteredFields = computed(() => {
    let filteredFields = fields.filter(
        (field) => field && ![null, "null"].includes(field.type),
    );

    if (withValues) {
        filteredFields = filteredFields.filter((field) => {
            if (!field.default_value) return false;
            if (
                Array.isArray(field.default_value) &&
                field.default_value.length === 0
            )
                return false;

            return true;
        });
    }

    return filteredFields;
});
</script>

<template>
    <UIDataList condensed no-container>
        <AppFieldDataListItem
            v-for="item in filteredFields"
            :key="item?.key"
            :item="item"
            @update:editable="$emit('update:editable', $event)"
            @update:deletable="$emit('update:deletable', $event)"
            @saved="$emit('saved', $event)"
            :editable="editable"
            :search="search"
            :noCopy="noCopy"
            :fields="filteredFields"
        />
    </UIDataList>
</template>
